<template>
	<div class="main-table">
		<div class="main-title-box">
			<div class="main-title1"><el-checkbox v-model="checked" @change="checkALL"></el-checkbox></div>
			<div class="main-title2">日期</div>
			<div class="main-title3">订单号</div>
			<div class="main-title4">品项/数量</div>
			<div class="main-title5"><span>全部状态</span><span v-if="active === '全部订单'"><i class="el-icon-arrow-down" @click="sortList('0')" v-show="orderSort !== '0'"></i><i class="el-icon-arrow-up" @click="sortList('1')" v-show="orderSort === '0'"></i></span></div>
			<div class="main-title6">操作</div>
		</div>
		<div class="main-table-box">
			<div class="main-content-box" v-for="(item) in tableData" :key="item.orderid" @dblclick="getDetail(item)">
				<div class="content-title">
					<div class="main-title1"><el-checkbox v-model="item.checked" @change="checkSingle"></el-checkbox></div>
					<div class="main-title7">
						<el-popover
							placement="bottom-start"
							trigger="hover">
							<div>
								<div>客户类别：{{item.customerCategoryName}}</div>
								<div>客户名称：{{item.customerName}}</div>
								<div>收货人：{{item.buyername}}</div>
								<div>手机号：{{item.buytel}}</div>
								<div>地址：{{item.address}}</div>
							</div>
							<span slot="reference"><span class="title-category">{{item.customerCategoryName}}：<span>{{item.customerName.length > 15 ? item.customerName.substring(0,15) + '...' : item.customerName}}</span></span><span class="title-custom">{{item.buyername}}   {{item.buytel}}</span></span>
						</el-popover>
					</div>
					<div class="main-title4 list-title4">
						<img src="~/images/icon/list-pay.png" v-if="item.archivestatus">
						<img src="~/images/icon/list-write-off.png" v-if="item.liquidateflag === 1">
					</div>
					<div class="main-title5" style="font-size:15px">￥{{item.finalprice}}</div>
					<div class="main-title6 titile6-detail">
						<div v-if="item.child.length > 1">
							共<span class="title6-bold">{{item.orderchildCount}}</span>个子订单<span v-if="item.refundchildCount !== 0">,及<span class="title6-bold">{{item.refundchildCount}}</span>个退单</span>
							<i class="el-icon-d-arrow-left" @click="childShowChange(item)" v-show="item.childShow"></i>
							<i class="el-icon-d-arrow-right" @click="childShowChange(item)" v-show="!item.childShow"></i>
						</div>
					</div>
				</div>
				<div class="content-content">
					<div class="content-left">
						<div class="left-main">
							<div class="main-content1"></div>
							<div class="main-content2">{{item.ordercreatedate}}</div>
							<div class="main-content3" :class="item.bold ? 'bold' : ''">{{item.ordernumber}}<span class="dai-text" v-if="item.ordersource === 1">代</span></div>
							<div class="main-content4" style="color:#333">{{item.attrplancount}} 种，数量：{{item.totalquantity}} 件</div>
							<div class="main-content5">
								<div class="state-icon state-pay" v-if="item.billState === '待付款'">待付款</div>
								<div class="state-icon state-get" v-if="item.billState === '待接单'">待接单</div>
								<div class="state-icon state-send" v-if="item.billState === '待发货'">待发货</div>
								<div class="state-icon state-prepare" v-if="item.billState === '备货中'">备货中</div>
								<div class="state-icon state-receive" v-if="item.billState === '待收货'">待收货</div>
								<div class="state-icon state-done" v-if="item.billState === '已完成'">已完成</div>
								<div class="state-icon state-cancel" v-if="item.billState === '已取消'">已取消</div>
							</div>
						</div>
						<div class="left-son" v-for="childItem in item.child" :key="childItem.orderchildid" v-show="item.childShow && item.child.length > 1">
							<div class="main-content1"></div>
							<div class="main-content2">{{childItem.createdate}}</div>
							<div class="main-content3" :class="childItem.bold ? 'bold' : ''">{{childItem.ordernumber}}<span class="tui-text" v-if="childItem.ordertype === 1">退</span></div>
							<div class="main-content4">{{childItem.attrplancount}} 种，数量：{{childItem.totalquantity}} 件</div>
							<div class="main-content5">
								<span>￥{{childItem.totalmoney}}</span>
								<span class="pay-way" v-if="childItem.archivestatus !== 0">({{childItem.paymentmode === 0 ? '线下' : childItem.paymentmode === 2 ? '微信' : ''}}{{childItem.ordertype === 0 ? '支付' : '退款'}})</span>
								<span class="pay-way" style="color:#EC4141" v-if="childItem.archivestatus === 0">(未{{childItem.ordertype === 0 ? '支付' : '退款'}})</span>
							</div>
						</div>
					</div>
					<div class="main-title6">
						<el-button type='text' size="mini" @click="getDetail(item)" v-if="(item.billState === '待付款' && (AuthorityList['07_0001_0002_00'] || AuthorityList['07_0001_0003_00'])) || (item.billState === '待接单' && (AuthorityList['07_0001_0005_00'] || AuthorityList['07_0001_0006_00'])) || (item.billState === '待发货' && (AuthorityList['07_0001_0008_00'] || AuthorityList['07_0001_0009_00'])) || (item.billState === '备货中' && item.sellpullstate === 1 && (AuthorityList['07_0001_0011_00'] || AuthorityList['07_0001_0012_00'])) || (item.billState === '待收货' && (AuthorityList['07_0001_0014_00'] || AuthorityList['07_0001_0015_00'])) || (item.billState === '已完成' && (AuthorityList['07_0001_0017_00'] || AuthorityList['07_0001_0018_00'])) || (item.billState === '已取消' && (AuthorityList['07_0001_0020_00'] || AuthorityList['07_0001_0021_00']))">详情</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog
			title="拒绝原因"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="300px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<el-radio-group v-model="refuseValue">
					<el-radio v-for="item in refuseArr" :label="item.id"  :key="item.id">{{item.name}}</el-radio>
				</el-radio-group>
				<el-input @change='othercauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="refuseValue !==10 && refuseValue !==4" type="textarea" v-model="othercauser"></el-input>
				<div class="btn-box">
					<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="refuseOrderConfirm">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="填写发货信息"
			:visible.sync="expressVisible"
			:close-on-click-modal="false"
			@close="expressClose"
			class="dialog-title"
			width="500px">
			<div class="dialog-body">
				<div class="delivery-box" style="margin-top:15px">
					<span>发货方式：</span>
					<el-select v-model="deleveryType" placeholder="请选择快递公司" size="mini" class="delivery-select">
						<el-option value="0" label="快递"></el-option>
						<el-option value="1" label="自提"></el-option>
					</el-select>
					<span style="margin-left:20px;">快递公司：</span>
					<el-select v-model="companycode" placeholder="请选择快递公司" size="mini" class="delivery-select">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.value"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="delivery-box">
					<span>物流单号：</span>
					<el-input
						style="width:250px;"
						size="small"
						v-model="code"
						placeholder="请输入物流单号"
						onkeyup="value=value.replace(/[^a-zA-Z0-9]/ig,'')"
						oninput="if(value.length>50)value=value.slice(0,50)"
					/>
				</div>
				<div class="express-btn">
					<el-button plain size="small" @click="closeExpress">取消</el-button>
					<el-button type="primary" size="small" @click="ensureSend">确认发货</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		active: {
			type: String
		},
		orderSort: {
			type: String
		},
		clddock: {
			type: Number,
			default: 0
		},
		backorderdock: {
			type: Number,
			default: 0
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			othercauser: '',
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			orderParams: {},
			sendData: {},
			refuseValue: 7,
			refuseArr: [],
			deleveryType: '0',
			companycode: '',
			refuseTakeOrder: [
				{ id: 7, name: '库存不足' },
				{ id: 8, name: '未达起送标准' },
				{ id: 9, name: '商品停售' },
				{ id: 10, name: '其他原因' }
			],
			refuseCancelOrder: [
				{ id: 0, name: '商品已经出库' },
				{ id: 1, name: '商品开始生产' },
				{ id: 2, name: '取消理由不合理' },
				{ id: 3, name: '申请已超时' },
				{ id: 4, name: '其他原因' }
			],
			options: [
				{ 'id': 'shunfeng', 'value': '顺丰' },
				{ 'id': 'yuantong', 'value': '圆通' },
				{ 'id': 'yunda', 'value': '韵达' },
				{ 'id': 'shentong', 'value': '申通' },
				{ 'id': 'huitongkuaidi', 'value': '百世' },
				{ 'id': 'zhongtong', 'value': '中通' },
				{ 'id': 'ems', 'value': 'EMS' },
				{ 'id': 'debangwuliu', 'value': '德邦' },
				{ 'id': 'debangkuaidi', 'value': '德邦快递' },
				{ 'id': 'youzhengbk', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong', 'value': '宅急送' },
				{ 'id': '0', 'value': '其他' }
			],
			code: '',
			dialogVisible: false,
			expressVisible: false,
			checked: false,
			curItemData: {},
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false,
				'07_0001_0022_00': false
			}
		}
	},
	created () {
		this.getAuthority('07_0001_0000_00')
	},
	methods: {
		expressClose () {
			this.deleveryType = '0'
			this.companycode = ''
			this.code = ''
		},
		closeExpress () {
			this.expressVisible = false
		},
		agreenRefuseCancel (data, bool) {
			let params = {}
			if (bool) {
				params = {
					orderid: data.orderid,
					statusid: data.statusId,
					buyerSellerType: '1',
					isAgreeCancel: bool,
					orderstatus: data.orderstatus
				}
			} else {
				params = {
					orderid: data.orderid,
					statusid: data.statusId,
					buyerSellerType: '1',
					othercauser: this.othercauser,
					isAgreeCancel: bool,
					cancelcause: this.refuseValue,
					orderstatus: data.orderstatus
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/agreecancel`,
				data: params
			}).then(res => {
				if (res.result) {
					this.dialogVisible = false
					if (bool) {
						this.$message.success('同意取消成功！')
					} else {
						this.$message.success('拒绝取消成功！')
					}
					this.$emit('modifySuc')
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		checkALL (type) {
			let ids = []
			this.tableData.forEach(item => {
				item.checked = type
				if (item.checked) {
					ids.push(item.orderid)
				}
			})



			this.$emit('selectIds', ids)
		},
		checkSingle () {
			let num = 0
			let ids = []
			this.tableData.forEach(item => {
				if (item.checked) {
					num += 1
					ids.push(item.orderid)
				}
			})
			this.checked = num === this.tableData.length


			this.$emit('selectIds', ids)
		},
		sortList (num) {
			this.$emit('sortList', num)
		},
		childShowChange (item, index) {
			item.childShow = !item.childShow
		},
		othercauserChange () {
			this.othercauser = this.othercauser.trim()
			this.othercauser = this.othercauser.replace(/[',\\]/g, '')
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.orderid
			})
			this.$emit('selectIds', ids)
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getDetail (value) {
			this.orderParams.orderId = value.orderid
			this.orderParams.statusId = value.statusId
			this.orderParams.differ = value.differ
			this.orderParams.buypullstate = value.buypullstate
			this.orderParams.billState = value.billState
			let orderParams = JSON.stringify(this.orderParams)
			window.sessionStorage.setItem('orderInfo', orderParams)
			this.$emit('saveSelect')
			this.$router.push('/dock/orderDetail')
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		},
		// 勾销
		liquidate (row, type) {
			let params = {
				liquidateflag: type,
				orderids: row.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		updateStatus (data, action) {
			let orderstatus
			if (action === 3) {
				orderstatus = 2
				this.sendData = data
				if (this.canundeliveredunpaysendflag) {
					this.expressVisible = true
				} else {
					if (data.archivestatus) {
						this.$message.error('有未支付子订单，不允许发货，请买家支付后，才能发货！')
						return false
					}
					this.expressVisible = true
				}
			} else {
				orderstatus = 1
				this.$confirm('是否接单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let params = {
						orderid: data.orderid,
						statusid: data.statusId,
						orderstatus: orderstatus,
						action: action,
						operateCode: 1020
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/order/update/status`,
						data: params
					}).then(res => {
						if (res.result) {
							if (action === 3) {
								if (data.pushstate !== '无法同步' && this.backorderdock !== 0 && this.clddock === 1) {
									this.$message.success('数据已经同步供应链系统、订单状态改变成功！')
								} else {
									this.$message.success('发货成功！')
								}
							} else {
								this.$message.success('接单成功！')
							}
							this.$emit('modifySuc')
						} else {
							let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
							this.$message.error(resMsg)
						}
					}).catch(() => {
						this.$message.error('订单状态已改变!')
					})
				}).catch(() => {})
			}
		},
		ensureSend () {
			let params = {
				orderid: this.sendData.orderid,
				statusid: this.sendData.statusId,
				orderstatus: 2,
				action: 3
			}
			if (this.deleveryType === '0') {
				let companyname = ''
				this.options.forEach(item => {
					if (item.id === this.companycode) {
						companyname = item.value
					}
				})
				params.express = {
					companyname: companyname,
					companycode: this.companycode,
					number: this.code
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/update/statusAndFulfillment`,
				data: params
			}).then(res => {
				if (res.result) {
					if (this.sendData.pushstate !== '无法同步' && this.backorderdock !== 0 && this.clddock === 1) {
						this.$message.success('数据已经同步供应链系统、订单状态改变成功！')
					} else {
						this.$message.success('发货成功！')
					}
					this.expressVisible = false
					this.$emit('modifySuc')
				} else {
					let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
					this.$message.error(resMsg)
				}
			}).catch(() => {
				this.$message.error('订单状态已改变!')
			})
		},
		close () {
			this.dialogVisible = false
		},
		refuseOrder (data, type) {
			if (type === 'take') {
				this.refuseArr = this.refuseTakeOrder
				this.refuseValue = 7
			} else {
				this.refuseArr = this.refuseCancelOrder
				this.refuseValue = 0
			}
			this.curItemData = data
			console.log(data, '111')
			this.dialogVisible = true
		},
		refuseOrderConfirm () {
			if (this.curItemData.billState === '待接单') {
				let params = {
					orderid: this.curItemData.orderid,
					statusid: this.curItemData.statusId,
					buyerSellerType: '1',
					cancelcause: this.refuseValue,
					othercauser: this.othercauser,
					orderstatus: this.curItemData.orderstatus,
					operateCode: 2040
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/cancel`,
					data: params
				}).then(res => {
					if (res.result) {
						this.dialogVisible = false
						// this.refuseValue = 7
						this.$message.success('拒单成功！')
						this.$emit('modifySuc')
					} else {
						let resMsg = res.msg === '' ? '订单状态已改变!' : res.msg
						this.$message.error(resMsg)
					}
				}).catch(() => {
					this.$message.error('订单状态已改变!')
				})
			} else {
				this.agreenRefuseCancel(this.curItemData, false)
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.bold {
		color: var(--fx-primary-color)
	}
	.main-title-box {
		width: 100%;
		height: 50px;
		line-height: 50px;
		color: #333;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		background-color: #F7F8FA
		div{
			text-align: center
			font-weight: bold
		}
	}
	.main-title1 {
		flex: 1
	}
	.main-title2 {
		flex: 5
	}
	.main-title3 {
		flex: 6
	}
	.main-title4 {
		flex: 9
		&.list-title4 {
			display: flex
			align-items: center
		}
		img {
			margin-left: 60px
		}
	}
	.main-title5 {
		flex: 5
		font-weight: bold
		i {
			padding-left: 10px
			cursor: pointer
		}
	}
	.main-title6 {
		flex: 7
		display: flex
		align-items: center;
		justify-content: center
		i {
			transform: rotate(90deg)
			cursor: pointer
			margin-left: 30px
			margin-right: 30px;
		}
		&.titile6-detail {
			justify-content: flex-end
			.title6-bold {
				font-weight: bold
				margin: 0 2px;
			}
		}
		.el-button--mini {
			font-size: 13px;
		}
	}
	.main-title7 {
		flex: 11
		text-align: left
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		.title-category {
			font-weight: bold
			color: 333;
			margin-right: 20px
			font-size: 15px
		}
		.title-custom {
			font-size: 13px
			color: 666
		}
	}
	.main-content1 {
		flex: 33
	}
	.main-content2 {
		flex: 165
		border-right: 1px solid #EDEFFC
	}
	.main-content3 {
		flex: 198
		border-right: 1px solid #EDEFFC
	}
	.main-content4 {
		flex: 297
		border-right: 1px solid #EDEFFC
	}
	.main-content5 {
		flex: 165
		display: flex;
		justify-content: center;
		align-items: center;
		border-right: 1px solid #EDEFFC
		.pay-way {
			color: #999;
			margin-left: 20px
		}
	}
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.main-content-box {
			width: 100%;
			color: #333;
			font-size: 14px;
			border: 1px solid #EDEFFC;
			box-shadow: 0px 2px 4px 1px rgba(199, 199, 199, 0.23);
			box-sizing: border-box;
			border-radius: 2px;
			margin-top: 10px
			&:hover {
				border: 1px solid var(--fx-primary-color)
			}
			.content-title {
				width: 100%
				height: 50px;
				line-height: 50px;
				background-color: #F0F3FA
				display: flex;
			}
			.content-content {
				display: flex
				.content-left {
					flex:26;
					display:flex
					flex-direction: column
					&>div{
						display: flex
					}
					.left-main {
						height: 60px;
						line-height: 60px
						color: #595959
						.state-icon {
							width: 59px;
							height: 26px;
							line-height: 27px;
							font-weight: bold;
							border-radius: 4px;
							font-size: 13px
						}
						.state-pay {
							background: rgba(236, 65, 65, 0.15)
							color: #EC4141
						}
						.state-get {
							background: rgba(238, 28, 117, 0.15)
							color: #EE1C75
						}
						.state-send {
							background: rgba(243, 142, 11, 0.15)
							color: #F38E0B
						}
						.state-prepare {
							background: rgba(49, 140, 242, 0.15)
							color: var(--fx-primary-color)
						}
						.state-receive {
							background: rgba(204, 116, 194, 0.15)
							color: #DC35C9
						}
						.state-done {
							background: rgba(61, 168, 28, 0.15)
							color: #3AB613
						}
						.state-cancel {
							background: rgba(125, 125, 125, 0.1)
							color: #666
						}
					}
					.left-son {
						height: 25px;
						line-height: 25px
						background-color: #F7F8FA
						font-size:13px
						color: #666
					}
					.dai-text {
						display: inline-block;
						width: 16px;
						height: 16px;
						line-height: 16px;
						border: 1px solid #F38E0B;
						border-radius: 4px;
						color: #F38E0B;
						font-size: 10px;
						transform: scale(0.9);
						margin-left: 3px;
					}
					.tui-text {
						display: inline-block;
						width: 16px;
						height: 16px;
						line-height: 16px;
						border: 1px solid #EC4141;
						border-radius: 4px;
						color: #EC4141;
						font-size: 10px;
						transform: scale(0.9);
						margin-left: 3px;
					}
				}
			}
		}
	}
	.dai-wrap {
		display: flex
		align-items: center
		justify-content: center;
		.dai-icon {
			width: 16px
			height: 16px
			vertical-align: top
			margin: -2px 0 0 2px
			flex-shrink: 0
		}
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.delivery-select {
		width: 150px;
	}
	.delivery-box {
		display: flex
		align-items: center
		margin-top: 25px;
	}
	.express-btn {
		text-align: right;
		margin-top: 35px;
	}
	.btn-box {
		display flex
		justify-content: center
		.el-button {
			width: 120px
		}
	}
}
</style>
